import React from "react";
import { withLocalize, Translate } from "react-localize-redux";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../store/reportStore';
import HistoryLink from "../../common/historyLink";

class CugTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            historyOpen: !this.props.isHistorical || this.props.resolveExpanded(false, false),
            isHistoryOpenTouched: false
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.isExpandAllActivated !== prevProps.isExpandAllActivated || this.props.isHideAllActivated !== prevProps.isHideAllActivated) {
            this.setState({
                isHistoryOpenTouched: false
            });
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.props.isHistorical > 0 &&
                    <HistoryLink historyExpanded={this.props.resolveExpanded(this.state.historyOpen, this.state.isHistoryOpenTouched)}
                        onClick={() => this.setState({
                            historyOpen: !this.props.resolveExpanded(this.state.historyOpen, this.state.isHistoryOpenTouched),
                            isHistoryOpenTouched: true
                        })
                    } />
                }
                {(!this.props.isHistorical || this.props.resolveExpanded(this.state.historyOpen, this.state.isHistoryOpenTouched)) && <>
                    {this.props.data.filter(x => x.openTotal !== 0 && x.isHistorical === this.props.isHistorical).length > 0 &&
                        <>
                            <table className={`small-padding table table-report-section${this.props.isHistorical ? " table-report-history" : ""}`}>
                                <thead>
                                    <tr>
                                        <th rowSpan="2"><Translate id="Report.Common.Source" /></th>
                                        <th rowSpan="2"><Translate id="AmlBulkExport.Description.UpdateDate" /></th>
                                        <th rowSpan="2" className="right"><Translate id="Report.Itrade.OverdueLiabilities" data={{ currency: this.props.currency }} /></th>
                                        <th colSpan="4" className='center'><Translate id="Report.Itrade.OverdueLiabilities2" data={{ currency: this.props.currency }} /></th>
                                    </tr>
                                    <tr>
                                        <th className="right">31-60</th>
                                        <th className="right">61-90</th>
                                        <th className="right">91-120</th>
                                        <th className="right">{">"} 120</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.data.filter(x => x.isHistorical === this.props.isHistorical && x.openTotal !== 0).map((rd, i) => <tr
                                        key={i} className='colorize'
                                    >
                                        <td>{rd.isContributor ? <Translate id="Report.Itrade.FromContributor" /> : <Translate id="Report.Itrade.Cug" />}</td>
                                        <td>{rd.periodFormatted}</td>
                                        <td className="right">{rd.openTotal !== 0 ? <>{rd.openTotal}</> : "-"} </td>
                                        <td className="right">{rd.open30 !== 0 ? <>{rd.open30}</> : "-"} </td>
                                        <td className="right">{rd.open60 !== 0 ? <>{rd.open60}</> : "-"} </td>
                                        <td className="right">{rd.open90 !== 0 ? <>{rd.open90}</> : "-"}</td>
                                        <td className="right">{rd.open120 !== 0 ? <>{rd.open120}</> : "-"} </td>
                                    </tr>)}
                                </tbody>
                            </table>
                            <span className='hide-on-desktop underlined-title-wrapper'>
                                <span className='underlined-title'><Translate id='Report.Itrade.OverdueLiabilities2' data={{ currency: this.props.currency }}/></span>
                            </span>
                        </>
                    }
                </>}
            </React.Fragment>
        )
    }
}
export default withLocalize(connect(
    state => state.report, dispatch => bindActionCreators(reportActions, dispatch)
)(CugTable));